module.exports = __webpack_public_path__ + "static/media/challenge_customize.d1311472.png";